import { Box } from "@vinomofo/components";

import { Button } from "../button";
import { Link } from "../link";
import { LinkProps } from "../link/Link";

export interface DividerLinkProps extends LinkProps {
  label: string;
}

export const DividerLink = ({
  to,
  label,
  isExternal,
}: DividerLinkProps): JSX.Element => {
  return (
    <Box display="flex" alignItems="center" width="100%">
      <Box
        as="hr"
        border={0}
        borderBottom="1px solid"
        borderBottomColor="divider"
        flexGrow={1}
        mr={3}
      />
      <Button as={Box} to={to} isExternal={isExternal}>
        {label}
      </Button>
      <Box
        as="hr"
        border={0}
        borderBottom="1px solid"
        borderBottomColor="divider"
        flexGrow={1}
        ml={3}
      />
    </Box>
  );
};
